"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _inputTextfield = require("@citrus/input-textfield");
var _reactList = _interopRequireDefault(require("@pcty/react-list"));
var _utilsArray = require("@pcty/utils-array");
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _PctyQuestion = require("./PctyQuestion.Common");
require("./index.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PctyQuestionConstantSum = function PctyQuestionConstantSum(_ref) {
  var _label, _label2, _label3, _span, _span2, _span3;
  var id = _ref.id,
    number = _ref.number,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    scenario = _ref.scenario,
    required = _ref.required,
    question = _ref.question,
    options = _ref.options,
    response = _ref.response,
    hint = _ref.hint,
    onResponse = _ref.onResponse,
    sortOrder = _ref.sortOrder,
    minimumValue = _ref.minimumValue,
    maximumValue = _ref.maximumValue,
    targetSumValue = _ref.targetSumValue,
    enforceTargetSum = _ref.enforceTargetSum,
    sumMustEqualCaption = _ref.sumMustEqualCaption,
    minimumInputCaption = _ref.minimumInputCaption,
    maximumInputCaption = _ref.maximumInputCaption,
    minAndMaxInputCaption = _ref.minAndMaxInputCaption,
    totalCaption = _ref.totalCaption,
    allocatedCaption = _ref.allocatedCaption,
    placeholder = _ref.placeholder;
  var getNumberValue = function getNumberValue(value) {
    return value ? value.replace(/\D/g, '') : value;
  };
  var getResponseTotalSum = function getResponseTotalSum(itemResponses) {
    var sum = 0;
    itemResponses.map(function (item) {
      var val = item.value ? parseInt(item.value) : 0;
      sum = sum + val;
      return sum;
    });
    return sum;
  };
  var defaultValidationState = {
    valid: true,
    errorMessage: '',
    showValidationState: false
  };
  var applyValidationRules = function applyValidationRules(array, optionId, value) {
    if (disabled || readOnly) return array;
    var items = (0, _toConsumableArray2.default)(array);
    var itemIndex = (0, _findIndex.default)(items, function (x) {
      return x.id === optionId;
    });
    if (itemIndex < 0) return;
    var fixedValue = getNumberValue(value);
    var intValue = fixedValue ? parseInt(fixedValue) : undefined;
    items[itemIndex].validationState = _objectSpread({}, defaultValidationState);

    // not valid if the min is greater than the input value
    if (minimumValue && parseInt(minimumValue) > intValue) {
      var invalid = {
        valid: false,
        errorMessage: 'Under minimum',
        showValidationState: true
      };
      items[itemIndex].validationState = _objectSpread(_objectSpread({}, defaultValidationState), invalid);
    }

    // not valid if the max is less than the input value
    if (maximumValue && parseInt(maximumValue) < intValue) {
      var _invalid = {
        valid: false,
        errorMessage: 'Over maximum',
        showValidationState: true
      };
      items[itemIndex].validationState = _objectSpread(_objectSpread({}, defaultValidationState), _invalid);
    }
    return items;
  };
  var getOptionsWithValidation = function getOptionsWithValidation(options, sortOrder, responses) {
    var items = (0, _PctyQuestion.getSortedOptions)({
      array: options,
      sortOrder: sortOrder
    }).map(function (o) {
      return {
        id: o.id,
        value: o.value,
        validationState: _objectSpread({}, defaultValidationState)
      };
    });
    if (responses && responses.length > 0) {
      responses.map(function (r) {
        items = applyValidationRules(items, r.optionId, r.value);
      });
    }
    return items;
  };
  var _useState = (0, _react.useState)(getOptionsWithValidation(options, sortOrder, response)),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentItems = _useState2[0],
    setCurrentItems = _useState2[1];
  var _useState3 = (0, _react.useState)(getResponseTotalSum((0, _toConsumableArray2.default)(response))),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    currentSum = _useState4[0],
    setCurrentSum = _useState4[1];
  (0, _react.useEffect)(function () {
    setCurrentItems(getOptionsWithValidation(options, sortOrder, response));
  }, [options, sortOrder]);
  var getResponseValue = function getResponseValue(itemId) {
    var selectedItem = response.length > 0 ? response.find(function (x) {
      return x.optionId === itemId;
    }) : undefined;
    if (selectedItem) {
      return selectedItem.value;
    }
    return undefined;
  };
  var _onChange = function onChange(id, optionId, value) {
    if (readOnly) return;

    // apply validation
    var items = applyValidationRules(currentItems, optionId, value);

    // update the state with validation info
    setCurrentItems(items);

    // fixup the value
    var fixedValue = getNumberValue(value);
    value = fixedValue && fixedValue.length > 0 ? fixedValue : undefined;

    // update the responses
    var itemResponses = (0, _toConsumableArray2.default)(response);
    var responseIndex = (0, _findIndex.default)(itemResponses, function (x) {
      return x.optionId === optionId;
    });
    var newResponse = {
      optionId: optionId,
      value: value
    };
    if (responseIndex < 0) {
      itemResponses = [].concat((0, _toConsumableArray2.default)(response), [newResponse]);
    } else {
      itemResponses = (0, _utilsArray.replaceAt)(itemResponses, responseIndex, newResponse);
    }

    // always remove any undefined items
    itemResponses = itemResponses.filter(function (x) {
      return x.value !== undefined;
    });

    // set the totalSum regardless if valid
    var sum = getResponseTotalSum(itemResponses);
    setCurrentSum(sum);
    onResponse(id, itemResponses);
  };
  var getListItems = function getListItems() {
    var retOptions = currentItems.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(_reactList.default.Item, {
        automationId: "question-".concat(number, "-constant-sum-item-").concat(index),
        key: "".concat(id, "-cs-item-").concat(index)
      }, /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, item.value), /*#__PURE__*/_react.default.createElement(_reactList.default.Column, {
        style: {
          width: '85px'
        }
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        formatter: function formatter(x) {
          return getNumberValue(x);
        },
        id: "".concat(item.id, "-cs-textfield-").concat(id.toString()),
        disabled: disabled,
        readOnly: readOnly,
        maxLength: 5,
        onChange: function onChange(_ref2) {
          var value = _ref2.value;
          return _onChange(id, item.id, value);
        },
        placeholder: placeholder,
        automationId: "question-".concat(number, "-constant-sum-textfield-").concat(index),
        showValidationState: item.validationState.showValidationState,
        valid: item.validationState.valid,
        value: getResponseValue(item.id)
      }), !item.validationState.valid && item.validationState.showValidationState && /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
      }, item.validationState.errorMessage)));
    });
    return retOptions;
  };
  var renderMinMaxLabel = function renderMinMaxLabel() {
    if (disabled || readOnly) return null;
    if (minimumValue && maximumValue) {
      return _label || (_label = /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, minAndMaxInputCaption));
    } else if (minimumValue && !maximumValue) {
      return _label2 || (_label2 = /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, minimumInputCaption));
    } else if (!minimumValue && maximumValue) {
      return _label3 || (_label3 = /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, maximumInputCaption));
    } else {
      return null;
    }
  };
  var renderSumLabel = function renderSumLabel() {
    if (enforceTargetSum) {
      if (currentSum === targetSumValue) {
        return /*#__PURE__*/_react.default.createElement("label", {
          className: "pcty-input-label pcty-color-green"
        }, "".concat(currentSum, "/").concat(targetSumValue), _span || (_span = /*#__PURE__*/_react.default.createElement("span", {
          className: "pcty-type-normal"
        }, " ", allocatedCaption)));
      } else if (currentSum > targetSumValue) {
        return /*#__PURE__*/_react.default.createElement("label", {
          className: "pcty-input-label pcty-color-red"
        }, "".concat(currentSum, "/").concat(targetSumValue), _span2 || (_span2 = /*#__PURE__*/_react.default.createElement("span", {
          className: "pcty-type-normal"
        }, " ", allocatedCaption)));
      } else {
        return /*#__PURE__*/_react.default.createElement("label", {
          className: "pcty-input-label"
        }, "".concat(currentSum, "/").concat(targetSumValue), _span3 || (_span3 = /*#__PURE__*/_react.default.createElement("span", {
          className: "pcty-type-normal"
        }, " ", allocatedCaption)));
      }
    } else {
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, "".concat(totalCaption, ": ").concat(currentSum));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestion.renderHint)(id, hint), (0, _PctyQuestion.renderScenario)(id, scenario), (0, _PctyQuestion.renderQuestion)(id, number, question, required, readOnly), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_reactList.default, {
    className: "pcty-question-builder-single-question-list",
    automationId: "question-".concat(number, "-constant-sum-list")
  }, getListItems(), /*#__PURE__*/_react.default.createElement(_reactList.default.Item, {
    className: "totals-row",
    automationId: "question-".concat(number, "-constant-sum-item-total"),
    key: "".concat(id, "-cs-item-targetsum")
  }, /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, !disabled && !readOnly && enforceTargetSum && /*#__PURE__*/_react.default.createElement("label", {
    className: "pcty-input-label"
  }, sumMustEqualCaption), renderMinMaxLabel()), /*#__PURE__*/_react.default.createElement(_reactList.default.Column, {
    style: {
      width: '140px'
    }
  }, renderSumLabel()))))));
};
PctyQuestionConstantSum.propTypes = {
  /** A hint that you want to give the person answering the question. */
  hint: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** The question number. */
  number: _propTypes.default.number.isRequired,
  /** Whether or not the question will be disabled. */
  disabled: _propTypes.default.bool,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** Whether or not the question will be displayed as required. */
  required: _propTypes.default.bool,
  /** Callback function that receives response information each time someone interacts with the question. */
  onResponse: _propTypes.default.func.isRequired,
  /** The array of option objects. */
  options: _propTypes.default.array.isRequired,
  /** The minimum value allowed to be specified in each answer field. */
  minimumValue: _propTypes.default.number,
  /** The maximum value allowed to be specified in each answer field. */
  maximumValue: _propTypes.default.number,
  /** The target sum value for which all values must add up to in order for the answer to be valid. */
  targetSumValue: _propTypes.default.number,
  /** Whether or not to enforce the target sum specified by targetSum */
  enforceTargetSum: _propTypes.default.bool,
  /** The question text. */
  question: _propTypes.default.string.isRequired,
  /** An array of response objects that are output from the component. */
  response: _propTypes.default.array,
  /** Some text that sets up your question. */
  scenario: _propTypes.default.string,
  /** The total caption text. */
  totalCaption: _propTypes.default.string,
  /** The allocated caption text. */
  allocatedCaption: _propTypes.default.string,
  /** The sum-must-equal caption text. */
  sumMustEqualCaption: _propTypes.default.string,
  /** The minimum-value caption text. */
  minimumInputCaption: _propTypes.default.string,
  /** The maximum-value caption text. */
  maximumInputCaption: _propTypes.default.string,
  /** The minimum and maxiumum-value caption text. */
  minAndMaxInputCaption: _propTypes.default.string,
  /** The sortOrder of the options of the component. */
  sortOrder: _propTypes.default.oneOf(['defined', 'ascending', 'descending', 'random']),
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionConstantSum');
  }
};
PctyQuestionConstantSum.defaultProps = {
  scenario: null,
  sortOrder: 'defined',
  minimumValue: undefined,
  maximumValue: undefined,
  enforceTargetSum: false,
  placeholder: 'Enter value',
  disabled: false,
  readOnly: false,
  totalCaption: 'Total',
  allocatedCaption: 'allocated',
  sumMustEqualCaption: 'The sum of all values must equal TARGET_SUM.',
  minimumInputCaption: 'Values must have a minimum of MINIMUM_INPUT.',
  maximumInputCaption: 'Values may have a maximum of MAXIMUM_INPUT.',
  minAndMaxInputCaption: 'Values must be between MINIMUM_INPUT and MAXIMUM_INPUT.',
  __TYPE: 'PctyQuestionConstantSum'
};
var _default = exports.default = PctyQuestionConstantSum;